  <template>
  <v-app class="d-flex flex-column align-space-between justify-space-between" id="inspire">
    <component :is="'script'" src="https://www.google.com/recaptcha/api.js?render=6Lczt7klAAAAAFkzMfU_cxcjaKZL1NuNYJCgDopi"></component>
    <v-progress-circular
      indeterminate
      color="green"
      v-if="this.loader"
      style="width:100%; margin-top: 30vh;"
    />
    <span v-else class="d-flex flex-column" style="height: 100%">
      <v-container fluid style="flex: 0 1 auto;">
        <v-row>
          <!--Desktop View-->
          <v-col class="d-none d-md-block">
            <span class="text-center d-flex flex-column align-center">
              <img src="./assets/judys-logo-2.png" width="366px;" alt="">
              <h1 style="color: black; margin-bottom: 5px; font-family: 'Cormorant', serif; font-size: 30px; font-weight: 600;">Appointment Booking</h1>
              <a class="mb-5" href="https://judysformalandbridal.com">Back to the main site.</a>
            </span>
            <v-container v-if="appointment.metadata">
              <v-row>
                <v-col cols="8" offset="2">
                  <v-stepper v-model="stepperProgress" alt-labels non-linear v-if="sessionStatus==0||sessionStatus==4">
                    <v-stepper-header>
                      <v-stepper-step @click="stepperProgress=1" editable :complete="stepperProgress===1" step="1"><span class="text-center" style="font-family: 'Cormorant', serif; font-size: 20px; font-weight: 600;">Contact Information</span></v-stepper-step>
                      <v-divider></v-divider>
                      <v-stepper-step @click="stepperProgress=2" editable :complete="stepperProgress===2" step="2"><span class="text-center" style="font-family: 'Cormorant', serif; font-size: 20px; font-weight: 600;">I want to...</span></v-stepper-step>
                      <v-divider></v-divider>
                      <v-stepper-step @click="stepperProgress=3" editable :complete="stepperProgress===3" step="3"><span class="text-center" style="font-family: 'Cormorant', serif; font-size: 20px; font-weight: 600;">Select Date and Time</span></v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                      <v-stepper-content step="1">
                        <v-card>
                          <h2 class="text-center" style="font-family: 'Cormorant', serif; font-size: 35px; font-weight: 600;">Contact Information</h2>
                          <span class="d-flex flex-column">
                            <v-checkbox @change="updateAppointment()" v-model="appointment.metadata.firstAppointment" label="This is my first appointment." style="color: black; font-family: 'Cormorant', serif;font-weight: 600;" />
                            <!-- <v-checkbox v-model="appointment.metadata.firstAppointment" label="This first apt."></v-checkbox> -->
                          </span>
                          <span class="d-flex flex-column">
                            <v-text-field required style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;" label="Name*" v-model="appointment.customerName" @change="updateAppointment()"/>
                            <v-text-field required style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;" ref="customerPhone" v-model="appointment.customerPhone" label="Phone*"></v-text-field>
                          </span>
                          <span class="d-flex flex-column">
                            <v-text-field v-if="sessionStatus != 4" required style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;" class="" label="Email*" v-model="appointment.customerEmail" @change="updateAppointment()"/>
                            <div style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;" v-else>Email: {{ appointment.customerEmail }}</div>
                            <v-text-field required style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;" label="Address Line 1*" v-model="appointment.customerLine1" @change="updateAppointment()"/>
                          </span>
                          <span class="d-flex flex-column">
                            <v-text-field required style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;" class="" label="Address Line 2" v-model="appointment.customerLine2" @change="updateAppointment()"/>
                            <v-text-field required style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;" label="Address City" v-model="appointment.customerCity" @change="updateAppointment()"/>
                          </span>
                          <v-menu
                              :close-on-content-click="false"
                              :nudge-right="0"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field required style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;"
                                            :value="utils.parseDate(appointment.weddingDate,2)"
                                            label="Wedding Date*"
                                            readonly

                                            clearable
                                            v-bind="attrs"
                                            v-on="on"
                                            class="mr-2"
                              />
                            </template>
                            <v-date-picker
                                @change="updateAppointment()"
                                v-model="appointment.weddingDate"
                            />
                          </v-menu>
                        </v-card>
                      </v-stepper-content>

                      <v-stepper-content step="2">
                        <v-card>
                          <h2 class="text-center" style="font-family: 'Cormorant', serif; font-size: 35px; font-weight: 600;">I want to...</h2>
                          <span class="d-flex flex-row justify-space-around flex-wrap pt-5">
                            <v-checkbox v-for="intention in intentions" :key="intention.id" @change="updateAppointment()" v-model="appointment.intentions" :label="intention.name" :value="intention.id" style="color: black; font-family: 'Cormorant', serif;font-weight: 600;" />
                          </span>
                          <span class="d-flex flex-column">
                            <v-text-field required style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;" label="Budget*" @change="updateAppointment()" type="number" v-model="appointment.budget"/>
                            <v-text-field required style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;" label="How many people are coming along?*" @change="updateAppointment()" type="number" v-model="appointment.occupants"/>
                            <v-select
                                style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;"
                                :items="genders"
                                item-text="name"
                                item-value="id"
                                label="Bride/Groom*"
                                v-model="appointment.gender"
                                @change="updateAppointment()"
                            />
                          </span>
                        </v-card>
                      </v-stepper-content>

                      <v-stepper-content step="3">
                        <v-card>
                          <div v-if="captchaVerified && emailVerified" class="d-flex flex-column mb-5" style="background-color: rgba(0,0,0,0);">
                            <v-row>
                              <v-col>
                                <h2 class="text-center" style="font-family: 'Cormorant', serif; font-size: 35px; font-weight: 600;">Select Date</h2>
                                <v-date-picker full-width v-model="appointment.scheduledForDate" @change="getDateSchedule"/>
                              </v-col>
                              <v-col>
                                <span class="d-flex flex-column align-center">
                                  <h2 class="text-center" style="font-family: 'Cormorant', serif; font-size: 35px; font-weight: 600;">Available Times</h2>
                                  <v-progress-circular
                                      indeterminate
                                      color="green"
                                      v-if="dateScheduleLoader"
                                      class="d-flex flex-row justify-center"
                                  ></v-progress-circular>
                                </span>

                                <h3>{{appointment.exemptionLabel}}</h3>
                                <span class="d-flex flex-column" v-if="dateSchedule && dateSchedule.length > 0">
                                  <div class="d-flex flex-row flex-wrap justify-start">
                                    <div class="mb-2 mx-1" elevation="0" v-for="(block,index) in dateSchedule" :key="index">
                                      <v-btn v-if="block.available" :color="`${block.isSelected?'teal':'light-grey'}`" :style="`${block.isSelected?'color: white;':'color:black;'}`" @click="setAppointmentBlock(index)">{{ utils.convert24HourTime(block.time) }}</v-btn>
                                    </div>
                                  </div>
                                </span>
                                <p v-else class="text-center">Select a Date</p>
                              </v-col>
                            </v-row>
                          </div>
                        </v-card>
                      </v-stepper-content>
                    </v-stepper-items>
                    <span class="d-flex flex-row justify-center pb-2">
                      <v-btn class="mx-1" color="light-grey" :disabled="stepperProgress==1" @click="stepperProgress--">Back</v-btn>
                      <v-btn class="mx-1" color="primary" :disabled="stepperProgress==3" @click="stepperProgress++">Next</v-btn>
                    </span>
                    <span class="d-flex flex-row justify-center pb-2">
                      <v-btn v-if="sessionStatus==0" color="info" :disabled="!appointment.isValid" @click="requestAppointmentOtp" :loading="appointment.isLoading">Proceed</v-btn>
                      <v-btn v-if="sessionStatus==4" color="success" :disabled="!appointment.isValid" @click="changeSessionStatus(1)">Done Editing</v-btn>
                    </span>
                  </v-stepper>

                  <span v-if="sessionStatus == 2" class="d-flex flex-column justify-center text-center">
                    <h2 style="font-family: 'Cormorant', serif; font-size: 35px; line-height: 40px; font-weight: 600;">You're All Set!</h2>
                    <b>Your confirmation code is {{ confirmationCode }}</b>
                    <p>You may close this window.</p>
                  </span>

                  <span v-if="sessionStatus==1|| sessionStatus==2 ||sessionStatus==5" class="d-flex flex-column col-6 offset-3 justify-center text-center">
                    <h2 v-if="sessionStatus != 2" class="pt-5" style="font-family: 'Cormorant', serif; font-size: 35px; line-height: 40px; font-weight: 600;">You're almost there!</h2>
                    <v-card outlined class="d-flex flex-column justify-center">
                      <v-card-title class="d-flex flex-row justify-center" style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 30px;">Summary</v-card-title>
                      <v-card-text>
                        <h3>{{ utils.customFormatDate(appointment.scheduledForDate, 'notime') }} at <b>{{ utils.convert24HourTime(appointment.scheduledForTime.time) }}</b></h3>
                        <b>For the {{ (this.genders.find(x=>x.id==appointment.gender)).name}}</b>
                        <br>
                        <b>Duration: 90 minutes</b>
                        <div>Budget: {{ utils.formatCurrency(appointment.budget) }}</div>
                        <div>Guests: {{ appointment.occupants }}</div>
                        <div v-if="appointment.customerEmail">Email: {{ appointment.customerEmail }}</div>
                        <div v-if="appointment.customerPhone">Phone: {{ appointment.customerPhone }}</div>
                        <b v-if="appointment.customerLine1">Address: </b>
                        <div>{{ appointment.customerLine1 }}</div>
                        <div v-if="appointment.customerLine2"> {{ appointment.customerLine2 }}</div>
                        <div v-if="appointment.customerCity">{{ appointment.customerCity }}</div>
                      </v-card-text>
                      <v-card-actions class="d-flex flex-row justify-center">
                        <v-btn v-if="sessionStatus != 2" text color="info" @click="changeSessionStatus(4)">Edit Appointment</v-btn>
                      </v-card-actions>
                    </v-card>
                  </span>

                  <span class="d-flex flex-column px-4">
                    <div v-if="sessionStatus==1||sessionStatus == 5" class="d-flex flex-column align-center text-center">
                      <h3 style="color: black; font-family: 'Cormorant', serif; font-size: 30px; font-weight: 600;">Check your email.</h3>
                      <i>We sent a code to your inbox ({{ appointment.customerEmail }}).<br/>Please enter that code below to confirm your booking.</i>
                      <a @click="openNoEmailDialog()"><b>I did not receive an email.</b></a>
                      <span class="col-3 d-flex flex-column align-center">
                        <v-text-field required style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;" class="mt-3" dense label="Enter Code" type="number" v-model="otpResponse"/>
                        <v-btn color="info" :disabled=" !otpResponse || otpResponse.length != 6" @click="confirmAppointmentOtp" :loading="appointment.isLoading">Complete Booking</v-btn>
                        <v-btn class="mt-3" v-if="sessionStatus==5" color="info" @click="requestAppointmentOtp" :loading="appointment.isLoading">Retry</v-btn>
                      </span>
                    </div>
                  </span>

                  <span class="d-flex flex-row justify-center text-center">
                    <v-btn v-if="sessionStatus==2" color="info" @click="startOver" :loading="appointment.isLoading">Create another appointment</v-btn>
                  </span>

                  <span v-if="sessionStatus==3" class="d-flex flex-column text-center justify-center col-6 offset-3">
                    <h2 style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 40px;">Oh no!</h2>
                    <b class="" style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;">There has been an error.</b>
                    <i v-if="errorMessage">{{ errorMessage }}</i>
                    <p style="font-family: 'Cormorant', serif; font-weight: 700; font-size: 16px;">Please call us to make your appointment.</p>
                    <span class="d-flex flex-row justify-center align-center">
                      <a :href="'tel:'+PHONE_NUMBER" style="text-decoration: none;"><v-btn class="mx-1" color="info">Call {{ PHONE_NUMBER }}</v-btn></a>
                      <v-btn v-if="sessionStatus==3" class="mx-1" color="info" @click="changeSessionStatus(0)" :loading="appointment.isLoading">Retry</v-btn>
                      <v-btn v-if="sessionStatus==3" class="mx-1" color="warning" @click="startOver" :loading="appointment.isLoading">Start Over</v-btn>
                    </span>
                  </span>
                </v-col>
              </v-row>
            </v-container>
          </v-col>

          <!--Mobile View-->
          <v-col class="d-md-none text-center">
            <img src="./assets/judys-logo-2.png" width="366px;" alt="">
            <h1 style="color: black; margin-bottom: 5px; font-family: 'Cormorant', serif; font-size: 30px; font-weight: 600;">Appointment Booking</h1>
            <a class="mb-5" href="https://judysformalandbridal.com">Back to the main site.</a>
            <v-card outlined v-if="appointment.metadata">
              <v-card-text class="pa-5" v-if="sessionStatus==0||sessionStatus==4">
                <h2 class="pl-5 pt-5" style="color: black; font-family: 'Cormorant', serif; font-size: 35px; font-weight: 600;">Contact Information</h2>
                <v-form class="d-flex flex-column" style="width: 100%;">
                <span class="d-flex flex-column">
                  <v-checkbox v-if="appointment.metadata" @change="updateAppointment()" v-model="appointment.metadata.firstAppointment" label="This is my first appointment." style="color: black; font-family: 'Cormorant', serif;font-weight: 600;" />
                </span>
                <span class="d-flex flex-column">
                  <v-text-field required style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;" label="Name*" v-model="appointment.customerName" @change="updateAppointment()"/>
                  <v-text-field required style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;" ref="customerPhone" v-model="appointment.customerPhone" label="Phone*"></v-text-field>
                </span>
                <span class="d-flex flex-column">
                  <v-text-field v-if="sessionStatus != 4" required style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;" class="" label="Email*" v-model="appointment.customerEmail" @change="updateAppointment()"/>
                  <div style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;" v-else>Email: {{ appointment.customerEmail }}</div>
                  <v-text-field required style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;" label="Address Line 1*" v-model="appointment.customerLine1" @change="updateAppointment()"/>
                </span>
                <span class="d-flex flex-column">
                  <v-text-field required style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;" class="" label="Address Line 2" v-model="appointment.customerLine2" @change="updateAppointment()"/>
                  <v-text-field required style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;" label="Address City" v-model="appointment.customerCity" @change="updateAppointment()"/>
                </span>
                <v-menu
                    :close-on-content-click="false"
                    :nudge-right="0"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field required style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;"
                                  :value="utils.parseDate(appointment.weddingDate,2)"
                                  label="Wedding Date*"
                                  readonly

                                  clearable
                                  v-bind="attrs"
                                  v-on="on"
                                  class="mr-2"
                    />
                  </template>
                  <v-date-picker
                      @change="updateAppointment()"
                      v-model="appointment.weddingDate"
                  />
                </v-menu>
                <h2 style="color: black; margin-bottom: 70px; font-family: 'Cormorant', serif; font-size: 35px; font-weight: 600;">I want to...</h2>
                <span class="d-flex flex-column">
                  <span class="mr-3" v-for="intention in intentions" :key="intention.id" style="margin-top: -30px;">
                    <v-checkbox @change="updateAppointment()" v-model="appointment.intentions" :label="intention.name" :value="intention.id" style="margin-top: -15px; color: black; margin-bottom: 30px; font-family: 'Cormorant', serif;font-weight: 600;" />
                  </span>
                </span>
                <span class="d-flex flex-column">
                  <v-text-field required style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;" label="Budget*" @change="updateAppointment()" type="number" v-model="appointment.budget"/>
                  <v-text-field required style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;" label="How many people are coming along?*" @change="updateAppointment()" type="number" v-model="appointment.occupants"/>
                  <v-select
                      style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;"
                      :items="genders"
                      item-text="name"
                      item-value="id"
                      label="Bride/Groom*"
                      v-model="appointment.gender"
                      @change="updateAppointment()"
                  />
                </span>
                <div v-if="captchaVerified && emailVerified" class="d-flex flex-column" style="background-color: rgba(0,0,0,0);">
                  <h2 class="my-5" style="color: black; margin-bottom: 30px; font-family: 'Cormorant', serif; font-size: 35px; font-weight: 600;">Select Date</h2>
                  <v-date-picker full-width v-model="appointment.scheduledForDate" @change="getDateSchedule"/>
                    <h2 class="my-5" style="color: black; margin-bottom: 30px; font-family: 'Cormorant', serif; font-size: 35px; font-weight: 600;">Available Times</h2>
                    <v-progress-circular
                        indeterminate
                        color="green"
                        v-if="dateScheduleLoader"
                        style="margin-left: 10px;"
                    ></v-progress-circular>
                    <h3>{{appointment.exemptionLabel }}</h3>
                    <span class="d-flex flex-column" v-if="dateSchedule && dateSchedule.length > 0">
                      <div class="d-flex flex-row flex-wrap justify-start">
                        <div class="mb-2 mx-1" elevation="0" v-for="(block,index) in dateSchedule" :key="index">
                          <v-btn v-if="block.available" :color="`${block.isSelected?'teal':'light-grey'}`" :style="`${block.isSelected?'color: white;':'color:black;'}`" @click="setAppointmentBlock(index)">{{ utils.convert24HourTime(block.time) }}</v-btn>
                        </div>
                      </div>
                    </span>
                    <span v-else>Select a date*</span>
                </div>
                </v-form>
              </v-card-text>
              <v-card-text v-if="sessionStatus == 2">
                <h2 style="font-family: 'Cormorant', serif; font-size: 35px; line-height: 40px; font-weight: 600;">You're All Set!</h2>
                <b>Your confirmation code is {{ confirmationCode }}</b>
                <p>You may close this window.</p>
              </v-card-text>
              <v-card-text v-if="sessionStatus==1|| sessionStatus==2 ||sessionStatus==5">
                <h2 v-if="sessionStatus != 2" class="" style="font-family: 'Cormorant', serif; font-size: 35px; line-height: 40px; font-weight: 600;">You're almost there!</h2>
                <v-card outlined class="d-flex flex-column align-center text-center">
                  <v-card-title style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 30px;">Summary</v-card-title>
                  <v-card-text >
                    <h3>{{ utils.customFormatDate(appointment.scheduledForDate, 'notime') }} at <b>{{ utils.convert24HourTime(appointment.scheduledForTime.time) }}</b></h3>
                    <b>For the {{ (this.genders.find(x=>x.id==appointment.gender)).name}}</b>
                    <br>
                    <b>Duration: 90 minutes</b>
                    <div>Budget: {{ utils.formatCurrency(appointment.budget) }}</div>
                    <div>Guests: {{ appointment.occupants }}</div>
                    <div v-if="appointment.customerEmail">Email: {{ appointment.customerEmail }}</div>
                    <div v-if="appointment.customerPhone">Phone: {{ appointment.customerPhone }}</div>
                    <b v-if="appointment.customerLine1">Address: </b>
                    <div>{{ appointment.customerLine1 }}</div>
                    <div v-if="appointment.customerLine2"> {{ appointment.customerLine2 }}</div>
                    <div v-if="appointment.customerCity">{{ appointment.customerCity }}</div>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn v-if="sessionStatus != 2" text color="info" @click="changeSessionStatus(4)">Edit Appointment</v-btn>
                  </v-card-actions>
                </v-card>
              </v-card-text>
              <div class="d-flex flex-column mb-8 px-4">
                <v-btn v-if="sessionStatus==0" color="info" block :disabled="!appointment.isValid" @click="requestAppointmentOtp" :loading="appointment.isLoading">Proceed</v-btn>
                <v-btn v-if="sessionStatus==4" color="success" block :disabled="!appointment.isValid" @click="changeSessionStatus(1)">Done Editing</v-btn>
                <div v-if="sessionStatus==1||sessionStatus == 5" class="d-flex flex-column">
                  <h3 style="color: black; font-family: 'Cormorant', serif; font-size: 30px; font-weight: 600;">Check your email.</h3>
                  <i>We sent a code to your inbox ({{ appointment.customerEmail }}). Please enter that code below to confirm your booking.</i>
                  <a @click="openNoEmailDialog()"><b>I did not receive an email.</b></a>
                  <v-text-field required style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;" class="mt-3" dense label="Enter Code" type="number" v-model="otpResponse"/>
                  <v-btn color="info" block :disabled=" !otpResponse || otpResponse.length != 6" @click="confirmAppointmentOtp" :loading="appointment.isLoading">Complete Booking</v-btn>
                  <v-btn class="mt-3" v-if="sessionStatus==5" color="info" block  @click="requestAppointmentOtp" :loading="appointment.isLoading">Retry</v-btn>
                </div>
                <v-btn class="mt-3" v-if="sessionStatus==2" color="info" block  @click="startOver" :loading="appointment.isLoading">Create another appointment</v-btn>
              </div>
              <v-card-text v-if="sessionStatus==3" class="d-flex flex-column justify-center">
                <h2 class="mb-5" style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 40px;">Oh no!</h2>
                <b class="mt-5" style="font-family: 'Cormorant', serif; font-weight: 600; font-size: 20px;">There has been an error.</b>
                <i v-if="errorMessage">{{ errorMessage }}</i>
                <p style="font-family: 'Cormorant', serif; font-weight: 700; font-size: 16px;">Please call us to make your appointment.</p>
                <a :href="'tel:'+PHONE_NUMBER" style="text-decoration: none;"><v-btn block color="info" class="mt-4">Call {{ PHONE_NUMBER }}</v-btn></a>
                <v-btn v-if="sessionStatus==3" class="mt-3" color="info" block @click="changeSessionStatus(0)" :loading="appointment.isLoading">Retry</v-btn>
                <v-btn v-if="sessionStatus==3" class="mt-3" color="warning" block @click="startOver" :loading="appointment.isLoading">Start Over</v-btn>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <div style="flex: 1 1 auto;"/>
      <v-footer style="flex: 0 1 40px;">{{ new Date().getFullYear() }} - Judy's Formal and Bridal Limited.</v-footer>
    </span>

    <v-dialog v-model="noEmailDialog.isOpen" width="400px">
      <v-card >
        <v-card-title class="text-h5">You didn't receive an email.</v-card-title>
        <v-card-text style="color: black;">
          <b>Please note the following:</b>
          <ul>
            <li>The email can take up to <strong>3 minutes</strong> to send.</li>
            <li>The email may be in your <b>SPAM</b> or <b>JUNK</b> inbox.</li>
            <li>The subject line is: "JUDY'S APPOINTMENT CODE", from "JUDYS@securemail.varion.co"</li>
            <li>Once you receive the email, you have 3 minutes before the code expires.</li>
          </ul>
          <b>You can also try resending the email ({{ this.EMAIL_LIMIT - this.getOtpCount + 1}} retries remaining), or call our helpdesk.</b>
          <v-btn block color="info" class="mt-4" :loading="appointment.isLoading" @click="requestAppointmentOtp">Retry Sending Email</v-btn>
          <a :href="'tel:'+PHONE_NUMBER" style="text-decoration: none;"><v-btn block color="info" class="mt-4">Call {{ PHONE_NUMBER }}</v-btn></a>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeNoEmailDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackObj.state" :timeout="3000" :color="snackObj.color">
      {{ snackObj.text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snackObj.state = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>
<style>
@import url('https://fonts.googleapis.com/css2?family=Cormorant&display=swap');

.v-stepper__step__step{
  width: 40px;
  height: 40px;
}
.v-stepper__step__step i{
  font-size: 2em;
}
</style>
<script>
  import { mapGetters, mapMutations } from "vuex"
  import axios from 'axios'
  import utils from "./plugins/helpers"
  export default {
    props: {
      source: String,
    },
    data: () => ({
      errorMessage: '',
      EMAIL_LIMIT: 10,
      PHONE_NUMBER: '655-4354',
      noEmailDialog: {
        isOpen: false,
        isLoading: false,
      },
      confirmationCode: '',
      otpResponse: "",
      captchaVerified: true,
      emailVerified: true,
      sessionStatus: 0, // 0 = no otp request, 1 = otp requested, 2 = booking confirmed, 3 = captcha failed; 4 = editing after otp req, 5 = otp expired allow retry btn
      utils: utils,
      dateScheduleLoader: false,
      dateSchedule: [],
      loader: false,
      appointment: {
        isValid: false,
        isLoading: false,
        intentions: [],
        gender: 0,
        metadata: {
          force: false,
          firstAppointment: true  
        },
        exemptionLabel: ''
      },
      intentions: [],
      genders: [
        {name: "None",id: 0},
        {name: "Groom",id: 1},
        {name: "Bride",id: 2}
      ],
      snackObj: {
        state: false,
        color: '',
        text: ''
      },
      stepperProgress: 1
    }),
    watch: {
      appointment: {
        handler(){
          console.log(this.appointment)
        },
        deep: true
      }
    },
    async mounted(){
      try {
        // let recaptchaScript = document.createElement("script");
        // recaptchaScript.setAttribute(
        //   "src",
        //   `https://www.google.com/recaptcha/api.js`
        // );
        // recaptchaScript.setAttribute("async", true);
        // recaptchaScript.setAttribute("defer", true);
        // document.head.appendChild(recaptchaScript);
        this.reloadApplication()
      } catch (error) {
        console.log(error)        
      }
    },
    computed: {
      ...mapGetters([
        'getEndpoint',
        'getGlobalValue',
        'getLocalAppointment',
        'getSessionStatus',
        'getSelectedDateBlockIndex',
        'getOtpCount',
        'getConfirmationCode'
      ])
    },
    methods: {
      ...mapMutations([
        'setEndpoint',
        'setGLOBALS',
        'setLocalAppointment',
        'robStore', //removes everything from store and localstorage
        'setSessionStatus',
        'setSelectedDateBlockIndex',
        'incrementOtpCount',
        'setConfirmationCode',
        'resetOtpCount',
        'resetSelectedDateBlockIndex',
        'resetConfirmationCode'
      ]),
      async startOver(){
        this.robStore()
        this.appointment = {}
        window.location.href = "/"        
      },
      openNoEmailDialog(){
        this.noEmailDialog.isOpen = true
      },
      closeNoEmailDialog(){
        this.noEmailDialog.isOpen = false
      },
      getCaptchaResponse(){
        console.log(window.grecaptcha.getResponse())
      },
      captchaReady(){
        console.log('capthca ready')
      },
      async reloadApplication(){
        try {
          this.loader = true
          // very important: determine what is the origin
          var origin = window.location.origin;
          if(origin == "https://bookings.judysformalandbridal.com"){
            this.setEndpoint(process.env.VUE_APP_CLOUD)
            console.log(`Origin: ${origin} | Endpoint Set: ${this.getEndpoint}`)
          }else if(origin == "http://admin.judys.vims"){
            this.setEndpoint(process.env.VUE_APP_PREM)
            console.log(`Origin: ${origin} | Endpoint Set: ${this.getEndpoint}`)
          }else if(origin.includes("http://localhost")){
            this.setEndpoint(process.env.VUE_APP_LOCALHOST)
            console.log(`Origin: ${origin} | Endpoint Set: ${this.getEndpoint}`)
          }else if(origin.includes("http://11.111.111.11")){
            this.setEndpoint(process.env.VUE_APP_PUBLIC)
            console.log(`Origin: ${origin} | Endpoint Set: ${this.getEndpoint}`)
          }else{
            this.setEndpoint(process.env.VUE_APP_EPHEMERAL)
            console.log(`Origin: ${origin} | Endpoint Set: ${this.getEndpoint}`)
          }

          this.sessionStatus = parseInt(this.getSessionStatus)
          if(!this.sessionStatus && this.sessionStatus !== 0){
            this.changeSessionStatus(0)
          }
          if(this.sessionStatus == 2){
            this.confirmationCode = this.getConfirmationCode
          }
          

          console.log(this.appointment) 
          this.appointment = this.getLocalAppointment
          
          console.log("From VUEX", this.appointment.gender)

          this.setGLOBALS((await axios.get(`${this.getEndpoint}/api/public/globals`)).data.data)

          let res = await axios.get(`${this.getEndpoint}/api/public/appointmentData`)
          if(res.data.error) throw res.data.error
          this.intentions = res.data.data.activityTypes

          if(this.appointment) {
            this.appointment.isLoading = this.appointment.isLoading === "true" 
            this.appointment.gender = parseInt(this.appointment.gender)
            if(this.appointment.scheduledForDate){
              console.log(this.appointment.scheduledForDate)
              await this.getDateSchedule()
              this.setAppointmentBlock(parseInt(this.getSelectedDateBlockIndex))
            }
          }
          // if(this.appointment.metadata.firstAppointment == null){
          //   this.appointment.metadata.firstAppointment = false
          // }

        } catch (error) {
          console.log(error)
        } finally {
          this.loader = false
        } 
      },
      async getDateSchedule(){
        try {
          if(!this.appointment.scheduledForDate) return
          
          this.appointment.exemptionLabel = ''
          this.dateScheduleLoader = true
          this.appointment.scheduledForTime = {}
          
          let res = await axios.get(`${this.getEndpoint}/api/public/byDate/${this.appointment.scheduledForDate}`)
          if(res.data.error) throw res.data.error
          
          let reservedBlocks = res.data.data
          console.log("reservedBlocks")
          console.log(reservedBlocks)
          this.dateSchedule = []
          let totalAvailableBlocks = (this.getGlobalValue('APPOINTMENT_AVAILABILITY_SCHEDULE'))

          let d = (new Date(this.appointment.scheduledForDate))
          let dayOfWeek = d.getUTCDay()
          let wordDayOfWeek = ["Sunday","Monday", "Tuesday","Wednesday", "Thursday", "Friday", "Saturday"]

          for(let block of totalAvailableBlocks.weekly[dayOfWeek]){
            for(let x = 0; x < parseInt(this.getGlobalValue('APPOINTMENTS_ALLOWED_SIMULTANEOUSLY')); x++){
              
              let isAvailable = true
              if(reservedBlocks.includes(block)){
                isAvailable = false
                reservedBlocks.splice(reservedBlocks.indexOf(block),1)
              }
              
              this.dateSchedule.push({
                block: x+1,
                dayWord: wordDayOfWeek[dayOfWeek],
                time: block,
                available: isAvailable, 
                isSelected: false
              })
              console.log(this.dateSchedule)

            }
          }

          for(let exemption of totalAvailableBlocks.dayExemptions){
            if(exemption.repeating==="N"){ // N exemptions are non-repeating exemptions that must contain a date in the format YYYY-MM-DD
              // let splittedDate = exemption.day.split('-')
              // let formattedExemptionDate = `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`
              // console.log(formattedExemptionDate,this.appointment.scheduledForDate)
              if(exemption.day==this.appointment.scheduledForDate){
                this.appointment.exemptionLabel = exemption.label
                if(!exemption.allowedTimes || exemption.allowedTimes.length == 0){
                  //block off entire day
                  this.dateSchedule.forEach(x=>x.available = false)
                }else {
                  this.dateSchedule.forEach(x=>x.available = false)
                  for(let x of exemption.allowedTimes){
                    //block off blocks that are specified in the array
                    for(let item of this.dateSchedule){
                      if(item.time == x){
                        item.available = true
                      }
                    }
                  }
                }
              }
            } else if(exemption.repeating==="W"){ // W exemptions are weekly-repeating exemptions that must contain the day key, whose value is an int, where sunday = 0 and saturday = 6
              console.log(exemption.day,d.getUTCDay())
              if(exemption.day==d.getUTCDay()){
                this.appointment.exemptionLabel = exemption.label
                if(!exemption.allowedTimes || exemption.allowedTimes.length == 0){
                  //block off entire day
                  this.dateSchedule.forEach(x=>x.available = false)
                }else {
                  this.dateSchedule.forEach(x=>x.available = false)
                  for(let x of exemption.allowedTimes){
                    //block off blocks that are specified in the array
                    for(let item of this.dateSchedule){
                      if(item.time == x){
                        item.available = true
                      }
                    }
                  }
                }
              }
            } else if(exemption.repeating==="M"){ // M exemptions are monthly-repeating exemptions that must contain the day key, whose value is an int that corresponds to the day of the month 
              if(exemption.day==d.getUTCDate()){
                this.appointment.exemptionLabel = exemption.label
                if(!exemption.allowedTimes || exemption.allowedTimes.length == 0){
                  //block off entire day
                  this.dateSchedule.forEach(x=>x.available = false)
                }else {
                  this.dateSchedule.forEach(x=>x.available = false)
                  for(let x of exemption.allowedTimes){
                    //block off blocks that are specified in the array
                    for(let item of this.dateSchedule){
                      if(item.time == x){
                        item.available = true
                      }
                    }
                  }
                }
              }
            } else if(exemption.repeating==="Y"){ // Y exemptions are yearly-repeating exemptions that must contain the day key, whose value is a string of the format DD/MM

              let splittedDate = exemption.day.split('/')
              let selectedDateSplitted = this.appointment.scheduledForDate.split("-")

              let formattedExemptionDay = splittedDate[0]
              let formattedExemptionMonth = splittedDate[1]
              let selectedDateDay = selectedDateSplitted[2]
              let selectedDateMonth = selectedDateSplitted[1]

              if(formattedExemptionMonth==selectedDateMonth && formattedExemptionDay==selectedDateDay){
                this.appointment.exemptionLabel = exemption.label
                console.log(exemption)
                if(!exemption.allowedTimes || exemption.allowedTimes.length == 0){
                  //block off entire day
                  this.dateSchedule.forEach(x=>x.available = false)
                }else {
                  this.dateSchedule.forEach(x=>x.available = false)
                  for(let x of exemption.allowedTimes){
                    //block off blocks that are specified in the array
                    for(let item of this.dateSchedule){
                      if(item.time == x){
                        item.available = true
                      }
                    }
                  }
                }
              }
            } else {
              this.appointment.exemptionLabel = ''
            }
          }

          this.updateAppointment()

        } catch (error) {
          console.log(error.msg || error)
          this.snack(error)
        } finally {
          this.dateScheduleLoader = false
        }
      },
      setAppointmentBlock(index){
        this.dateSchedule.forEach(block=>block.isSelected = false)
        
        this.dateSchedule[index].isSelected = true
        
        this.appointment.scheduledForTime = this.dateSchedule[index]
        let x = new Date(this.appointment.scheduledForDate)
        let h = parseInt((this.appointment.scheduledForTime.time)?.split(":")[0])
        let m = parseInt((this.appointment.scheduledForTime.time)?.split(":")[1])
        x.setUTCHours(h)
        x.setUTCMinutes(m)
        this.appointment.scheduledFor = x
        this.setSelectedDateBlockIndex(index)
        this.updateAppointment()
      },
      waitingOnCaptchaExecuteFn(secret){
        return new Promise((resolve)=>{
          window.grecaptcha.execute(secret, {}).then(async function(token) {
            resolve({token: token})
          })
        })
      },
      async finishedWaitingOnCaptchaExecuteFn(params){
        return await this.waitingOnCaptchaExecuteFn(params);
      },
      waitingOnCaptchaReadyFn(secret){
          return new Promise((resolve)=>{
              window.grecaptcha.ready(async ()=>{
                resolve({token: await this.finishedWaitingOnCaptchaExecuteFn(secret)})
              })
          })
      },
      async finishedWaitingOnCaptchaReadyFn(params){
          return await this.waitingOnCaptchaReadyFn(params);
      },
      async changeSessionStatus(s){
        this.sessionStatus = s
        this.setSessionStatus(s)
        if(s===0){
          this.stepperProgress=1;
        }
      },
      async requestAppointmentOtp(){
        try {
          this.appointment.isLoading = true;
          if(this.getOtpCount > this.EMAIL_LIMIT) throw "Too many email requests were made. Please call us to make your appointment."
          let obj = {appointment: this.appointment, token: await this.finishedWaitingOnCaptchaReadyFn(process.env.VUE_APP_CAPTCHA)}
          let res = await axios.post(`${this.getEndpoint}/api/public/requestEmailOtp`, obj)
          if(res.data.error) throw res.data.error;
          if(res.data.data == 200){
            this.snack("✅ Email Sent!")
            this.changeSessionStatus(1)
            this.incrementOtpCount()
          }
          else throw res.data.data 
          
        } catch (error) {
          console.log(error)
          this.snack(error)
          this.changeSessionStatus(3)
        } finally {
          this.appointment.isLoading = false
        }
      },
      async confirmAppointmentOtp(){
        try {
          this.appointment.isLoading = true;

          let obj = {
            appointment: this.appointment,
            otp: this.otpResponse
          }

          let res = await axios.post(`${this.getEndpoint}/api/public/confirmEmailOtpAndBook`, obj)
          if(res.data.error) throw res.data.error;
          
          this.confirmationCode = res.data.data.appointment.id
          this.setConfirmationCode(this.confirmationCode)
          this.changeSessionStatus(2)

        } catch (error) {
          console.log(error)
          this.snack(error)
          if(error === "Code has expired. Please retry."){
            this.changeSessionStatus(5)
          }else{
            this.changeSessionStatus(3)
          }
          this.errorMessage = error
          this.getDateSchedule()
          this.otpResponse = ''          
        }finally {
          this.appointment.isLoading = false;
        }
      },
      updateAppointment(){
        let temp = true
        if(!this.appointment) temp = false
        if(this.appointment.intentions.length < 1) temp = false
        if(!this.appointment.budget) temp = false
        if(!this.appointment.occupants) temp = false
        if(!this.appointment.customerName) temp = false
        if(!this.appointment.customerPhone) temp = false
        if(!this.appointment.scheduledFor || !this.appointment.scheduledForTime   || (Object.keys(this.appointment.scheduledForTime).length == 0) || !this.appointment.scheduledForDate) temp = false
        if(!this.appointment.weddingDate) temp = false
        this.appointment.isValid = temp
        this.setLocalAppointment(this.appointment)
        // if(selectedIndex || selectedIndex===0)
        //   this.setSelectedDateBlockIndex(selectedIndex)
      },
      getGreeting(){
        if(this.getUser != null && this.getUser != undefined){
          let d = new Date().getHours()
          let h = ''
          if(d >= 0 && d < 11) h = 'Morning'
          if(d >= 11 && d < 14) h = 'Day'
          if(d >= 14 && d < 17) h = 'Afternoon'
          if(d >= 17 && d < 19) h = 'Evening'
          if(d >= 19 && d <= 23) h = 'Night'
          return 'Good ' + h + ', ' + this.getUser.firstName.split(" ")[0] + '!'
        }
      },
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.state = true;
        this.snackObj.color = color;

      }
    },
  }
</script>